import React from 'react';
import partner1 from '../../Assets/partner1.svg';
import partner2 from '../../Assets/partner4.svg';
import partner3 from '../../Assets/partner3.svg';
import panchi from '../../Assets/panchi.svg';
import './About.css'
import Services from '../Home/Services/Services';

const About = () => {
    return (
        <div className="container my-md-0 my-5">
            <div className="theme-bg mx-md-5 py-md-5">
                <div className='row about-text p-0 d-flex justify-content-center align-items-center'>
                    <div className="col-md-2 d-flex justify-content-center align-items-center panchi-img d-none d-md-block">
                        <img src={panchi} alt="" />
                    </div>
                    <div className="col-md-9 about-text px-md-5 py-2 p-4">
                        <h4 className='theme-font'><span className='fw-bold'>पंछी.com</span> is a Service provider in social media marketing and IT solutions, encourages them to provide the information we need to give the creative stuff, then helps those users through the screening process. <span className='fw-bold'>पंछी.com</span> goal is not the goal is to not only get the attention of potential customers but also earn their trust. Once they apply one of opanchhi's agents guides then through the process </h4>
                        <h4 className='theme-font'>The websites's goal is not the goal is to not only get the attention of potential customers but also provide a job portal; platform where anyone can join us and work togather. We are here to utilize the trigger your creative mind to grow a better society a better lifecycle.</h4>
                    </div>
                </div>
                <div className='text-center'>
                    <h4 className='fw-bold'>Our Partners</h4>
                    <div className="row d-flex justify-content-around align-items-center partners px-md-5 py-2">
                        <div className="col-md-3 col-6">
                            <img src={partner1} alt="" />
                        </div>
                        <div className="col-md-3 col-6">
                            <img src={partner2} alt="" />
                        </div>
                        <div className="col-md-3 col-6 ps-5">
                            <img src={partner3} alt="" />
                        </div>
                        <div className="col-md-3 col-6">
                            <img src={partner2} alt="" />
                        </div>
                    </div>
                </div>
                <Services/>
            </div>
        </div>
    );
};

export default About;